// šis ir tas pats api, tikai neizmanto pinia userStore. token ņem no localStorage
import axios from 'axios'
import type { AxiosError } from 'axios'

// pievienojam default Authorization header axios
export const api = axios.create({ baseURL: String(import.meta.env.VITE_API_URL) })

// Token info
let tokenRefresh: boolean = false // is token being refreshed?
let curtoken: iToken | null = readToken('pieeja')

function readToken(tname: string): iToken | null {
  const acc_loc_token = localStorage.getItem(tname)
  if (acc_loc_token) {
    return {
      access_token: acc_loc_token,
      refresh_token: localStorage.getItem(`${tname}_atjaunot`) || '',
      access_token_expires: localStorage.getItem(`${tname}_beidzas`) || '',
      refresh_token_expires: localStorage.getItem(`${tname}_atjaunot_beidzas`) || '',
      access_token_expires_d: new Date(localStorage.getItem(`${tname}_beidzas`) || ''),
      refresh_token_expires_d: new Date(localStorage.getItem(`${tname}_atjaunot_beidzas`) || ''),
    }
  }
  return null
}

function saveToken(tname: string, token: iToken): void {
  localStorage.setItem(tname, token.access_token)
  localStorage.setItem(`${tname}_atjaunot`, token.refresh_token)
  localStorage.setItem(`${tname}_beidzas`, token.access_token_expires)
  localStorage.setItem(`${tname}_atjaunot_beidzas`, token.refresh_token_expires)
}

/** Atjaunojam token */
async function refreshToken(token: iToken): Promise<iToken | null> {
  try {
    const response = await api.post<iToken>(
      `/auth/refresh-token?refresh_token=${token.refresh_token}`,
    )
    const newtoken: iToken = {
      access_token: response.data.access_token,
      refresh_token: response.data.refresh_token,
      access_token_expires: response.data.access_token_expires.split('.')[0] + 'Z',
      refresh_token_expires: response.data.refresh_token_expires.split('.')[0] + 'Z',
      access_token_expires_d: new Date(response.data.access_token_expires),
      refresh_token_expires_d: new Date(response.data.refresh_token_expires),
    }
    saveToken('pieeja', newtoken)
    return newtoken
  } catch (error) {
    console.error('Error refreshing token:', error)
    return null
  }
}

// on request add token to header
api.interceptors.request.use(
  async function (config) {
    if (curtoken) {
      const curdate = new Date()
      // neattiecas uz refresh token
      if (!config.url?.startsWith('/auth/refresh-token')) {
        // other calls wait for token refresh
        if (tokenRefresh) {
          while (tokenRefresh) {
            await new Promise((resolve) => setTimeout(resolve, 1000))
          }
        }
        // refresh token if needed
        else if (
          curtoken.access_token_expires_d < curdate &&
          curtoken.refresh_token_expires_d > curdate
        ) {
          tokenRefresh = true
          curtoken = await refreshToken(curtoken)
          tokenRefresh = false
        }
      }
      // token is set
      if (curtoken && curtoken.access_token) {
        config.headers['Authorization'] = `Bearer ${curtoken.access_token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// on response parse error
api.interceptors.response.use(
  function (response) {
    return response
  },
  function (error: AxiosError<FastAPIresponse>) {
    // is there api error?
    if (error.response?.data?.detail) {
      // multiple errors
      if (typeof error.response.data.detail === 'string') {
        return Promise.reject(error.response.data.detail)
      } else {
        const reterr: string[] = []
        for (const curerr of error.response.data.detail) {
          reterr.push(`${curerr.loc.join(':')}: ${curerr.msg}`)
        }
        return Promise.reject(reterr.join('\n'))
      }
    }
    return Promise.reject(error.message)
  },
)
